import { render, staticRenderFns } from "./EgresoCreate.vue?vue&type=template&id=23b32dcd&lang=es"
import script from "./EgresoCreate.vue?vue&type=script&lang=js"
export * from "./EgresoCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports